import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const QuotationProjectRowSkeleton = ({ rowIndex = 0 }) => (
  <div className={`card mt-1 quote-project-row quote-skeleton-row ${rowIndex % 2 === 0 ? "row-even" : "row-odd"}`}>
    <div className="card-body">
      <div className="quote-project-grid">
        <div className="project-cell d-flex align-items-center">
          <Skeleton
            containerClassName="quote-project-skeleton-avatar mr-2"
            reactangle
            width={26}
            height={26}
          />
          <div className="project-copy mt-2 quote-project-skeleton-copy">
            <h4>
              <Skeleton
                containerClassName="quote-project-skeleton-name"
                width="78%"
                height={11}
              />
            </h4>
            <span><Skeleton width={110} height={11} /></span>
          </div>
        </div>
        <div className="ref-cell"><Skeleton width={110} height={13} /></div>
        <div className="distributor-cell"><Skeleton width="70%" height={13} /></div>
        <div className="country-cell"><Skeleton width={70} height={13} /></div>
        <div className="amount-cell quoted-cell"><Skeleton width={90} height={13} /></div>
        <div className="amount-cell order-cell"><Skeleton width={70} height={13} /></div>
        <div className="open-cell"><Skeleton width={24} height={24} /></div>
      </div>
    </div>
  </div>
);

export default React.memo(QuotationProjectRowSkeleton);
